import { useState, useEffect, useMemo } from 'react'
import api from '../components/api'
import MaterialReactTable from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import Badge from 'react-bootstrap/Badge';

const Tokens = () => {

    const [resultado, setResultado] = useState([])


    const columns = useMemo(
        () => [
            {
            accessorKey: 'token', //access nested data with dot notation
            header: 'Token',
            },
            {
            accessorKey: 'ad_new',
            header: 'Gerado em',
            },
            {
            accessorKey: 'nome',
            header: 'Por',
            },
    
            {
            accessorKey: 'valido',
            header: 'Válido',
            Cell: ({ renderedCellValue, row }) => (
            
                //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'A' ? 'warning' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : renderedCellValue == null || renderedCellValue == 'P' ? 'primary' : 'warning' }`}>{rotuloEnviado(renderedCellValue)}</span>
                //<Badge style={{  backgroundColor: renderedCellValue == 'Z' ? '#c769c7' : renderedCellValue == 'P' ? '#ffc4ab' : renderedCellValue == 'S' || renderedCellValue == null  ? '#7edeed' : renderedCellValue == 'A' ? '#ebe7b2' : renderedCellValue == 'V' ? '#59d970' : '#003366'  }}>{rotuloEnviado(renderedCellValue)}</Badge>
                <Badge style={{  backgroundColor: renderedCellValue == true ? 'green' : 'red' }}>{renderedCellValue == true ? 'Sim' : 'Não'}</Badge>
                
           
            ),
            },
    
        ],
        [],
        );

    const gerarToken = () => {


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma gerar novo token? (Isso invalidará todos os tokens anteriores)',
		    buttons: {
		        Sim: function () {

                    
                    
                    var dataPost = {

                        us_codigo: sessionStorage.getItem('us_codigo') ? Number(sessionStorage.getItem('us_codigo')) : null,

                    }

                    api.post('token', dataPost).then((result) => {

                        //console.log(result.data, 'aqui')
                        if (result.data.status == 'ok') {

                            window.toastr.success('Token gerado com sucesso')
                            listaTokens()

                        }
                        

                    }).catch((err) => {
                        console.log(err)
                        console.log(err.response)

                    })
                    

                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });


    }

    const listaTokens = () => {
        
        api.get('tokens').then((result) => {
            //console.log(result.data)
            setResultado(result.data)
            

        }).catch((err) => {
            console.log(err.response)
        })

    }

    useEffect(() => {
        listaTokens()
    }, []) 

    return (

        <div>
                <div className='content-header'>
                    <div className='header-icon'>
                        <i className='pe-7s-key'></i>
                    </div>
                    <div className='header-title'>
                        <h1>Administração</h1>
                        <small>Tokens</small>
                        
                    </div>

                </div>

                <div class="col-md-12">


                    <button type="button" class="btn btn-success" onClick={() => gerarToken()}>Gerar token</button>&nbsp;
                    
                    <br/><br/>


                </div>

                <div className="col-sm-12"  style={{ display: resultado ? 'block' : 'none'}}>
                                        
                                            
                                                
                    <div className="table-responsive">
                        
                            <MaterialReactTable 

                                columns={columns} 
                                data={resultado} 
                                localization={MRT_Localization_PT_BR}
                                //rowsPerPage={20}
                                //options={options}
                                initialState={{ density: 'compact' }}
                                muiTableHeadCellProps={{
                                    //easier way to create media queries, no useMediaQuery hook needed.
                                    sx: {
                                    fontSize: {
                                        xs: '8px',
                                        sm: '9px',
                                        md: '10px',
                                        lg: '11px',
                                        xl: '12px',
                                    },
                                    },
                                }}
                                muiTableBodyCellProps={{
                                    sx: {
                                        fontSize: {
                                        xs: '8px',
                                        sm: '9px',
                                        md: '10px',
                                        lg: '11px',
                                        xl: '12px',
                                        },
                                    },
                                }}
                                muiTableBodyRowProps={({ row }) => ({
                                onClick: (event) => {
                                    //console.info(event, row.original.usuario_id);
                                    //history.push(`AdesaoInstitucional/${row.original.adesao_institucional_id}`)
                                    //window.$('.modal-MovimentoEdit').modal('show');setMovimento_id(row.original.movimento_id)
                                    //history.push(`AdesaoInstitucional/${row.original.adesao_institucional_id}`)
                                    //setAno(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); setResiduo_id(row.original.residuo_id); window.$("#modalResiduos").modal('show')
                                    //setAno(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); setHospClima_id(row.original.hospClima_id); window.$("#modalDesafioClima").modal('show')

                                },
                                sx: {
                                    cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                                },
                                })}
                            />
                    </div>
                
            
        
    </div>

        </div>

    )

}

export default Tokens